import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RichTextViewer from 'components/rich-text-viewer/rich-text-viewer';
import FilesComponent from 'components/files/files';
const QuestionPairing = ({ questionId, question, getRawAnswer, answers, questions, instructionsFile, getLocalAnswers }) => {
    const { t } = useTranslation();
    const [isDirt, setIsDirt] = useState(false);
    const [localAnswers, setLocalAnswers] = useState([]);
    let initialState;
    useEffect(() => {
        setIsDirt(false);
        initialState = getRawAnswer(question);
        const local = [];
        setLocalAnswers(local);
        questions.forEach(question => {
            if (initialState && initialState.userAnswer) {
                const initialOption = initialState.userAnswer.find(state => state.questionId === question.id);
                if (initialOption) {
                    local.push({
                        questionId: question.id,
                        answerId: initialOption === null || initialOption === void 0 ? void 0 : initialOption.answerId,
                    });
                    return;
                }
            }
            local.push({
                questionId: question.id,
                answerId: -1,
            });
        });
        setLocalAnswers(local);
    }, [questionId]);
    useEffect(() => {
        if (!isDirt) {
            return;
        }
        if (localAnswers.length === 0) {
            return;
        }
        const serializedUserAnswer = JSON.stringify(initialState === null || initialState === void 0 ? void 0 : initialState.userAnswer);
        const serializedLocalAnswer = JSON.stringify(localAnswers);
        if (serializedUserAnswer === serializedLocalAnswer) {
            return;
        }
        getLocalAnswers(localAnswers);
    }, [localAnswers]);
    const shuffle = array => {
        let currentIndex = array.length;
        let randomIndex;
        // While there remain elements to shuffle...
        while (currentIndex != 0) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }
        return array;
    };
    const bindAnswer = (questionId, answerId) => {
        const edited = localAnswers.map(answer => {
            if (answer.questionId !== questionId) {
                return answer;
            }
            return {
                questionId,
                answerId,
            };
        });
        setIsDirt(true);
        setLocalAnswers(edited);
    };
    const getAnswerSelected = (item) => {
        const option = localAnswers.find(local => local.questionId === item.id);
        if ((option === null || option === void 0 ? void 0 : option.answerId) !== -1) {
            return option === null || option === void 0 ? void 0 : option.answerId;
        }
        return -1;
    };
    return (_jsxs(_Fragment, { children: [_jsx("form", Object.assign({ className: "form--student-exam" }, { children: questions.map(item => (_jsxs("fieldset", Object.assign({ className: "fieldset--two-columns" }, { children: [_jsx(RichTextViewer, { id: `question-${question.id}-answer-${item.id}`, content: item.title }, void 0), _jsxs("select", Object.assign({ className: "ml-3", onChange: event => bindAnswer(item.id, +event.target.value), value: getAnswerSelected(item) }, { children: [_jsx("option", Object.assign({ value: -1 }, { children: t('QUESTION.PAIRING.SELECT_OPTION') }), void 0), shuffle(answers.slice()).map(answer => (_jsx("option", Object.assign({ value: answer.id }, { children: answer.title }), answer.id)))] }), void 0)] }), item.id))) }), void 0), instructionsFile && (_jsx(FilesComponent, { file: instructionsFile }, void 0))] }, void 0));
};
export default QuestionPairing;
